const cptName = 'mieszkania';
const taxName = 'kategoria-inwestycji';
const hotspotsFlats = document.querySelector('#flats-for-hotspots');
const hotspotsFloors = document.querySelector('#floors-for-hotspots');
const hotspotsHouses = document.querySelector('#houses-for-hotspots');
const hotspotsGarages = document.querySelector('#garages-for-hotspots');
const hotspotsLockers = document.querySelector('#lockers-for-hotspots');
const chooseFloor = document.querySelector('.chooseFloor');
const flatsArr = [];
const floorsArr = [];
const housesArr = [];
const garagesArr = [];
const lockersArr = [];

if (hotspotsFlats) {
    Array.from(hotspotsFlats.children).forEach((hotspotFlat) => {
        flatsArr.push({
            title: hotspotFlat.children[0].textContent,
            status: hotspotFlat.children[1].textContent,
            link: hotspotFlat.children[2].textContent,
        });
    });
}

if (hotspotsFloors) {
    Array.from(hotspotsFloors.children).forEach((hotspotFloor) => {
        floorsArr.push({
            title: hotspotFloor.children[0].textContent,
            freeRooms: hotspotFloor.children[1].textContent,
            bookedRooms: hotspotFloor.children[2].textContent,
            soldRooms: hotspotFloor.children[3].textContent,
            link: hotspotFloor.children[4].textContent,
        });
    });
}

if (hotspotsHouses) {
    Array.from(hotspotsHouses.children).forEach((hotspotHouse) => {
        housesArr.push({
            title: hotspotHouse.children[0].textContent,
            status: hotspotHouse.children[1].textContent,
            link: hotspotHouse.children[2].textContent,
        });
    });
}

if (hotspotsGarages) {
    Array.from(hotspotsGarages.children).forEach((hotspotGarage) => {
        garagesArr.push({
            title: hotspotGarage.children[0].textContent,
            status: hotspotGarage.children[1].textContent,
            link: hotspotGarage.children[2].textContent,
        });
    });
}

if (hotspotsLockers) {
    Array.from(hotspotsLockers.children).forEach((hotspotLocker) => {
        lockersArr.push({
            title: hotspotLocker.children[0].textContent,
            status: hotspotLocker.children[1].textContent,
            link: hotspotLocker.children[2].textContent,
        });
    });
}

const waitForElm = (selector) => {
    return new Promise((resolve) => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver((mutations) => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
};

waitForElm('.hotspots-map').then(() => {
    const hotspotsInfo = document.querySelectorAll('.hotspot-info');

    if (hotspotsInfo.length > 0) {
        hotspotsInfo.forEach((hotspot) => {
            const title = hotspot.children[0];
            const description = hotspot.children[1];

            if (flatsArr.length > 0) {
                if (title && title.textContent.includes(cptName)) {
                    const flatObj = flatsArr.find((flat) => flat.link === title.textContent);

                    if (flatObj) {
                        title.textContent = flatObj.title;
                        description.textContent = flatObj.status;

                        title.classList.add('flat-title-tooltip');
                        description.classList.add('status', `status--${flatObj.status}`);

                        const checkFlat = document.createElement('span');
                        checkFlat.innerHTML = 'Zobacz mieszkanie';
                        checkFlat.classList.add('flat-check-tooltip');
                        hotspot.appendChild(checkFlat);
                    }
                }
            }

            if (floorsArr.length > 0) {
                if (title && title.textContent.includes(taxName)) {
                    const floorObj = floorsArr.find((floor) => floor.link === title.textContent);
                    if (floorObj) {
                        title.textContent = floorObj.title;
                        title.classList.add('floor-title-tooltip');

                        const freeRooms = document.createElement('div');
                        freeRooms.style.marginTop = '10px';
                        const bookedRooms = document.createElement('div');
                        const soldRooms = document.createElement('div');

                        freeRooms.innerHTML = `<span class="status status--Wolne">Wolne</span><span>${floorObj.freeRooms}</span>`;
                        bookedRooms.innerHTML = `<span class="status status--Rezerwacja">Zarezerwowane</span><span>${floorObj.bookedRooms}</span>`;
                        soldRooms.innerHTML = `<span class="status status--Sprzedane">Sprzedane</span><span>${floorObj.soldRooms}</span>`;

                        freeRooms.classList.add('floor-amount-tooltip');
                        bookedRooms.classList.add('floor-amount-tooltip');
                        soldRooms.classList.add('floor-amount-tooltip');

                        hotspot.appendChild(freeRooms);
                        hotspot.appendChild(bookedRooms);
                        hotspot.appendChild(soldRooms);

                        const checkFloor = document.createElement('span');
                        checkFloor.innerHTML = 'Zobacz mieszkania';
                        checkFloor.classList.add('floor-check-tooltip');
                        hotspot.appendChild(checkFloor);
                    }
                }
            }

            if (housesArr.length > 0) {
                if (title && title.textContent.includes(cptName)) {
                    const houseObj = housesArr.find((house) => house.link === title.textContent);

                    if (houseObj) {
                        title.textContent = houseObj.title;
                        description.textContent = houseObj.status;

                        title.classList.add('flat-title-tooltip');
                        description.classList.add('status', `status--${houseObj.status}`);

                        const checkHouse = document.createElement('span');
                        checkHouse.innerHTML = 'Zobacz dom';
                        checkHouse.classList.add('flat-check-tooltip');
                        hotspot.appendChild(checkHouse);
                    }
                }
            }

            if (garagesArr.length > 0) {
                if (title && title.textContent.includes(cptName)) {
                    const garageObj = garagesArr.find(
                        (garage) => garage.link === title.textContent,
                    );

                    if (garageObj) {
                        title.textContent = garageObj.title;
                        description.textContent = garageObj.status;

                        title.classList.add('flat-title-tooltip');
                        description.classList.add('status', `status--${garageObj.status}`);

                        const checkGarage = document.createElement('span');
                        checkGarage.innerHTML = 'Zobacz garaż';
                        checkGarage.classList.add('flat-check-tooltip');
                        hotspot.appendChild(checkGarage);
                    }
                }
            }

            if (lockersArr.length > 0) {
                if (title && title.textContent.includes(cptName)) {
                    const lockerObj = lockersArr.find(
                        (locker) => locker.link === title.textContent,
                    );

                    if (lockerObj) {
                        title.textContent = lockerObj.title;
                        description.textContent = lockerObj.status;

                        title.classList.add('flat-title-tooltip');
                        description.classList.add('status', `status--${lockerObj.status}`);

                        const checkLocker = document.createElement('span');
                        checkLocker.innerHTML = 'Zobacz komórkę';
                        checkLocker.classList.add('flat-check-tooltip');
                        hotspot.appendChild(checkLocker);
                    }
                }
            }
        });
    }
});

waitForElm('.hotspots-map-container').then(() => {
    const hotspotsPath = document.querySelectorAll('.hotspot-default.leaflet-interactive');

    if (hotspotsPath) {
        hotspotsPath.forEach((path) => {
            const name = path.getAttribute('name');
            const ariaLabel = path.getAttribute('aria-label');

            path.addEventListener('mouseover', () => {
                chooseFloor.style.opacity = '0';
            });

            path.addEventListener('mouseout', () => {
                chooseFloor.style.opacity = '1';
            });

            if (flatsArr.length > 0) {
                if (name.includes(cptName) && ariaLabel.includes(cptName)) {
                    const flatObj = flatsArr.find((flat) => flat.link === name);

                    if (flatObj) {
                        path.addEventListener('click', () => {
                            window.open(flatObj.link, '_self');
                        });

                        path.classList.add(flatObj.status);
                    }
                }
            }

            if (floorsArr.length > 0) {
                if (name.includes(taxName) && ariaLabel.includes(taxName)) {
                    const floorObj = floorsArr.find((floor) => floor.link === name);

                    if (floorObj) {
                        path.addEventListener('click', () => {
                            window.open(floorObj.link, '_self');
                        });

                        path.classList.add(floorObj.status);
                    }
                }
            }

            if (housesArr.length > 0) {
                if (name.includes(cptName) && ariaLabel.includes(cptName)) {
                    const houseObj = housesArr.find((house) => house.link === name);

                    if (houseObj) {
                        path.addEventListener('click', () => {
                            window.open(houseObj.link, '_self');
                        });

                        path.classList.add(houseObj.status);
                    }
                }
            }

            if (garagesArr.length > 0) {
                if (name.includes(cptName) && ariaLabel.includes(cptName)) {
                    const garageObj = garagesArr.find((garage) => garage.link === name);

                    if (garageObj) {
                        path.addEventListener('click', () => {
                            window.open(garageObj.link, '_self');
                        });

                        path.classList.add(garageObj.status);
                    }
                }
            }

            if (lockersArr.length > 0) {
                if (name.includes(cptName) && ariaLabel.includes(cptName)) {
                    const lockerObj = lockersArr.find((locker) => locker.link === name);

                    if (lockerObj) {
                        path.addEventListener('click', () => {
                            window.open(lockerObj.link, '_self');
                        });

                        path.classList.add(lockerObj.status);
                    }
                }
            }
        });
    }
});
